import AxiosInstance from "@/components/Axios";
import { SimilarProjectInterface } from "../Interface/SimilarProjectInterface";

export async function getSimilarProjects(project_id: string): Promise<SimilarProjectInterface[]> {
    const response = await AxiosInstance.get(`/api/projects/similar/${project_id}`);
    return response.data;
}

